import store from '../store'
import Vue from 'vue'

Vue.mixin({
  computed: {
    manufacturers: () => store.getters.manufacturers,
  },
})